export default __webpack_public_path__ + "static/media/logo-white.44bc8b5b.png";